import PopupLayout from "../../../../common/components/layouts/popupLayout/popupLayout";
import { Markup } from "interweave";
import Button, {
  ButtonTypes,
} from "../../../../common/components/button/button";
import "./campaignPolicyPopup.scss";

export default function CampaignPolicyPopup(props: {
  text?: string;
  fontStyle?: string;
  onAccept?: () => void;
  onDecline?: () => void;
}) {
  return (
    <PopupLayout onClickClose={props.onDecline}>
      <div className="policy-content-container">
        <div className="policy-content" style={{ fontStyle: props.fontStyle }}>
          <Markup content={props.text} />
        </div>
        <div className="policy-buttons-container">
          <Button
            type={ButtonTypes.OUTLINED}
            text={"Decline"}
            onClick={props.onDecline}
          />
          <Button
            type={ButtonTypes.PRIMARY}
            text={"Accept"}
            onClick={props.onAccept}
          />
        </div>
      </div>
    </PopupLayout>
  );
}
